import React,{useState} from 'react'
import './generated.css'

import { FillingBottle } from "react-cssfx-loading";

//image
import whatsapp from './assets/whatsapp.png'

export default function Generated() {

    const [count,setCount] = useState(0)

    const [time,setTime] = useState(false)

    setTimeout(()=>{
        setTime(true)
    },4000)

    const onShare = () =>{
        setCount(count+1)
        window.open('whatsapp://send?text=Get Free BGMI UC \n https://bgmi-uc.netlify.app/', '_blank')
    }

    return (
        <>
            <div>
                {
                    time ?
                    <>
                        <p className="title">Generated Successfully</p>
                <hr></hr>
                <div>
                    <p className="txts">You Will Receive Your Reward in your In-Game Mail.</p>
                    <p className="txts">With in <span className="red"> 6 </span> Hours</p>
                    <hr></hr>
                    <p className="txts">If you want to receive with in <span className="green">1 Hour</span></p>
                    <p className="txts">Share to 3 Groups or Friends</p>
                    <hr></hr>
                    <div className="img_container" onClick={onShare}>
                        <img className="img_whatsapp" src={whatsapp} alt="whatsapp" />
                    </div>
                    <p className="txts" onClick={onShare}>SHARE</p>
                    <p className="txts"><span className={count>1?"green":"red"}>{count}</span> of 3 Shares</p>
                    <hr></hr>
                    {
                        count>=3?<>
                        <p className="txts">Thanks For Sharing</p>
                    <h4 className="shadow">You Will Receive Your Reward With-In 1 Hour</h4>
                    </>
                    :null
                    }
                </div>
                    </>:
                    <div className="disp_center_loading">
                        <FillingBottle />
                    </div>
                }
            </div>
        </>
    )
}
